import { useDailyRoomStats } from "../hooks/useDailyRoomStats";

export default function StatsBar() {
  const { count, loading, error } = useDailyRoomStats();

  // Only worth bragging about once it's a real number — show nothing while
  // loading, on error, or until more than 10 rooms have been created today.
  if (loading || error || !count || count <= 10) return null;

  return (
    <div className="w-full bg-red-50 border-b border-red-100 px-4 py-2">
      <p className="text-center text-sm font-medium text-red-600">
        🔥 <span className="font-bold">{count.toLocaleString()}</span>{" "}
        {count === 1 ? "room" : "rooms"} created today
      </p>
    </div>
  );
}
